import { InitialStore } from "./state";

export type StoreAction = {
  type: string;
  payload?: any;
};

export const reducer = function (
  state: InitialStore,
  action: StoreAction
): InitialStore {
  switch (action.type) {
    case "changeState":
      return { ...state, ...action.payload};
    case "updateRuleAgreeStatus":
      return {
        ...state,
        isAgreeRule: action.payload
      }
    case "updateWorkData":
      return {
        ...state,
        workData: action.payload
      }
    case 'updateLoginStatus':
      return {
        ...state,
        isLogin: action.payload
      }
    default:
      throw new Error();
  }
};
